import { useTheme } from '@emotion/react'

import {
  AllerganMonoLogo,
  IbmMonoLogo,
  DominosMonoLogo,
  MongoDbMonoLogo,
  SanofiMonoLogo,
} from '@segment/matcha/components/CompanyLogos/CompanyMono'
import {
  AllerganLogo,
  IbmLogo,
  DominosLogo,
  MongoDbLogo,
  SanofiLogo,
} from '@segment/matcha/components/CompanyLogos/Company'

const testimonialData = () => {
  const theme = useTheme()
  return [
    {
      company: `allergan`,
      text: (
        <>
          “We lean heavily on Segment today to identify our consumers and their profile traits, what makes them them,
          and what kind of journey they are on. So, being able to have that integration with Twilio to be able to{` `}
          <mark>
            send communications to users based on their journey status is a pivotal piece of bringing those magic
            moments to life
          </mark>
          .“
        </>
      ),
      name: `Tory Brady`,
      position: `Associate Vice President, Product, Engineering & Data at Allergan Data Labs`,
      logo: <AllerganMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <AllerganLogo />,
      logoName: `Allergan`,
      extendedText: `in sales driven in 2021 YTD by direct-to-consumer (DTC)`,
    },
    {
      company: `ibm`,
      text: (
        <>
          “With real-time integrated data flows from Segment, we can truly{` `}
          <mark>understand what people are doing</mark>
          {` `}
          with our platform.”
        </>
      ),
      logo: <IbmMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <IbmLogo />,
      logoName: `Ibm`,
    },
    {
      company: `sanofi`,
      text: (
        <>
          “The process before Segment was much more cumbersome and difficult to explain to marketers. Now, Segment
          allows us to compile data all in one place, forming a Golden Profile, and allows for other teams to{` `}
          <mark>easily utilize and activate data</mark>.“
        </>
      ),
      name: `Rick Troiani`,
      position: `Director of Omni-Channel Engagement Architecture, Sanofi`,
      logo: <SanofiMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <SanofiLogo />,
      logoName: `sanofi`,
      extendedRate: `93%`,
      extendedText: `time saved adding new data sources`,
      extendedLink: `/customers/sanofi/`,
    },
    {
      company: `mongodb`,
      text: (
        <>
          “Since implementing Segment we have seen a significant increase in revenue which we attribute to the{` `}
          <mark>improved targeting and personalization of our communications</mark>.“
        </>
      ),
      name: `Ale Dimitriu`,
      position: `Senior Marketing Operations Manager, MongoDB`,
      logo: <MongoDbMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <MongoDbLogo />,
      logoName: `mongodb`,
      extendedRate: `100x`,
      extendedText: `increased registration rates`,
      extendedLink: `/customers/mongodb/`,
    },
    {
      text: (
        <>
          “Having Segment not only helped us do the personalization work we’ve always wanted to do, but we can now{` `}
          <mark>improve on the effectiveness of our ad campaigns</mark>
          {` `}and create a better feedback loop.”
        </>
      ),
      company: `dominos`,
      logo: <DominosMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <DominosLogo />,
      logoName: `Domino's`,
      extendedText: `decreased cost per acquisition`,
    },
  ]
}

export { testimonialData }
